<template>
  <div class="page-compact">
    <crm-panel :title="'成本列表'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.contractDeleteCost && auth.contractDeleteCost.toggleStatus"
          :buttonType="'plain'"
          :text="'批量删除'"
          @click="handleMoreDelete()"
        >
        </crm-button>
        <crm-button
          v-if="auth.contractUploadCost && auth.contractUploadCost.toggleStatus"
          :buttonType="'plain'"
          :text="'导入'"
          :disabled="isImportDisabled"
          @click="handleImport()"
        >
        </crm-button>
        <crm-button
          v-if="auth.contractDownloadCost && auth.contractDownloadCost.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select v-model="searchDateType">
                <el-option label="产生日期" :value="1"></el-option>
                <el-option label="创建日期" :value="2"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="searchTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <we-search-input-type-options v-once />
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 回款列表 -->
      <el-table
        :data="costDataList && costDataList.results"
        height="100%"
        v-loading="loading"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"> </el-table-column>
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="合同编号"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope)">{{
              scope.row.contractNo
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="客户名称"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCustomClick(scope)">{{
              scope.row.customerName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="salesmanName" align="center" label="业务员">
        </el-table-column>
        <el-table-column prop="costAmount" align="center" label="成本"> </el-table-column>
        <el-table-column prop="costDate" align="center" label="产生日期">
        </el-table-column>
        <el-table-column prop="costType" align="center" label="费用类型">
        </el-table-column>
        <el-table-column prop="payee" align="center" label="收款方"> </el-table-column>
        <el-table-column prop="creatorName" align="center" label="创建人">
        </el-table-column>
        <el-table-column prop="createdDate" align="center" label="创建日期">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="remarks" align="center" label="备注">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleDelete(row.costId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 回款列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="pagenation.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="(costDataList && costDataList.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 合同详情侧面板 -->
    <transition name="slide-fade">
      <template v-if="envCrm">
        <div v-show="compactDetailVisibleInside">
          <compact-detail-inside
            :row="row"
            :detailId="detailId"
            :detailTabName="detailTabName"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail-inside>
        </div>
      </template>
      <template v-else>
        <div v-show="compactDetailVisible">
          <compact-detail
            :detailId="detailId"
            :detailTabName="detailTabName"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail>
        </div>
      </template>
    </transition>

    <!-- 客户详情侧面板 -->
    <we-custom-details
      v-if="customDetailShow"
      v-bind="viewPanel"
      :sourcePart="'customer'"
      @closeCustomDetail="closeCustomDetail"
      @saveEditCustom="handleSearch"
      @success="handleSearch()"
    >
    </we-custom-details>

    <crm-upload
      :visible="isShowUplaod"
      :upload="upload"
      :handleClose="handleCloseUpload"
      download="/api/crmcontract/download/costtemp"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import config from "~config";
import { newDownloadByUrl, isEmptyObj } from "@/scripts/utils";
import crmPanel from "@/components/base/crmPanel";
import crmButton from "@/components/base/crmButton";
import crmUpload from "@/components/base/crmUpload";
import WeSearchInputTypeOptions from "~component/business/compact/search-input-type-options";
import WeCustomDetails from "~component/business/custom/customDetails.vue";
import CompactDetail from "~component/business/compact/detail.vue";
import CompactDetailInside from "@/pages/compact-inside/component";
import cookie from 'js-cookie'

export default {
  components: {
    WeSearchInputTypeOptions,
    CompactDetail,
    CompactDetailInside,
    WeCustomDetails,
    crmPanel,
    crmButton,
    crmUpload,
  },
  data() {
    return {
      loading: false,
      isShowUplaod: false, // 导入按钮
      isImportDisabled: false,
      isExportDisabled: false, // 导出按钮
      searchDate: {
        // 日期搜索
        createdStartDate: null,
        createdEndDate: null,
        costStartDate: null,
        costEndDate: null,
      },
      searchForm: {
        // 名字搜索
        customerName: null,
        customerNo: null,
        contractNo: null,
        salesmanName: null,
      },
      searchDateType: 1,
      searchTime: [],
      searchName: "",
      searchNameType: "customerName",
      // 列表选中项
      multipleSelection: [],
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      // 合同详情
      compactDetailVisible: false,
      compactDetailVisibleInside: false,
      detailId: null,
      detailTabName: null,
      // 查看客户详情
      customDetailShow: false,
      // 客户查看面板
      customRow: {},
      viewPanel: {
        uid: "",
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
      },
      envCrm: cookie.get("_env_crm__") !== "false",
      row: {},
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      customAuth: "authority/customAuth",
      costDataList: "compact/costDataList",
      webCustomerAuth: "authority/webCustomerAuth",
      customDetail: "customer/customDetail",
    }),
  },
  watch: {
    searchTime: {
      handler: "handleSearch",
    },
    searchDateType: {
      handler: "handleSearch",
    },
  },
  created() {
    this.handleSearch();
    if (Object.keys(this.customAuth).length === 0)
      this.getAuthority({ menuUrl: "/customer/valid" });
  },
  methods: {
    ...mapActions({
      getAuthority: "authority/getAuthority",
      getCostDataList: "compact/getCostDataList",
      upload: "compact/uploadCost",
      apiCostDelete: "compact/apiCostDelete",
      apiCostDeletelist: "compact/apiCostDeletelist",
      getCustomDetail: "customer/getCustomDetail",
    }),
    // 合同详情
    handleCompactDetailShow(scope, tabName) {
      if (this.envCrm) {
        this.row = scope.row;
        this.detailId = scope.row.contractId;
        this.compactDetailVisibleInside = true;
        setTimeout(() => {
          this.detailTabName = tabName || null
        }, 10)
      } else {
        this.detailId = scope.row.contractId;
        this.compactDetailVisible = true;
        if (tabName) {
          this.detailTabName = tabName;
        } else {
          this.detailTabName = null;
        }
      }
    },
    handleCloseCompactDetail(isRefresh) {
      this.compactDetailVisible = false;
      this.compactDetailVisibleInside = false;
      this.detailTabName = ''
      if (isRefresh) {
        this.handleSearch();
      }
    },
    // 客户详情
    async handleCustomClick(scope) {
      if (scope.row.customerIsDeleted === 1) {
        this.$message({
          type: "error",
          message: "该客户不存在或已删除",
        });
      } else {
        await this.getCustomDetail({
          sourcePart: "customer",
          uid: scope.row.customerId,
        }).then(() => {
          if (!isEmptyObj(this.customDetail)) {
            this.customRow = scope.row;
            this.customDetailShow = true;
            this.viewPanel = Object.assign(this.viewPanel, {
              uid: scope.row.customerId,
              type: scope.row.customerType,
              teamId: scope.row.teamId,
              authEdit:
                !scope.row.searchUid && this.customAuth.customerUpdate.toggleStatus,
              authDelete: this.customAuth.customerDelete.toggleStatus,
            });
          }
        });
      }
    },
    closeCustomDetail() {
      this.customDetailShow = false;
      this.handleSearch();
    },
    // 导入
    handleImport() {
      this.isImportDisabled = true;
      this.isShowUplaod = true;
    },
    handleCloseUpload() {
      this.isImportDisabled = false;
      this.isShowUplaod = false;
      this.handleSearch();
    },
    // 导出
    async handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      this.handleSearchData();
      const params = {
        ...this.pagenation,
        ...this.searchForm,
        ...this.searchDate,
      };

      let url = `${config.api || ""}/api/crmcontract/download/cost/page?`;
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      await newDownloadByUrl(url);
      this.isExportDisabled = false;
      if (this.notify) this.notify.close();
    },
    // 处理搜索数据
    handleSearchData() {
      this.searchDate = {
        createdStartDate: null,
        createdEndDate: null,
        costStartDate: null,
        costEndDate: null,
      };
      const dateList = ["cost", "created"];
      if (this.searchTime && this.searchTime.length > 0) {
        this.searchDate[
          `${dateList[this.searchDateType - 1]}StartDate`
        ] = this.searchTime[0];
        this.searchDate[
          `${dateList[this.searchDateType - 1]}EndDate`
        ] = this.searchTime[1];
      }

      const nameList = ["customerName", "customerNo", "contractNo", "salesmanName"];
      nameList.forEach((i) => {
        this.searchForm[i] = null;
      });
      if (this.searchName) this.searchForm[this.searchNameType] = this.searchName;
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList();
    },
    // 根据条件刷新合同列表
    handleGetCompactList() {
      this.loading = true;
      this.handleSearchData();
      this.getCostDataList({
        ...this.pagenation,
        ...this.searchForm,
        ...this.searchDate,
      }).finally(() => {
        this.loading = false;
      });
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetCompactList(this.pagenation);
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetCompactList(this.pagenation);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 删除
    handleDelete(id) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.apiCostDeletelist({ delCostIds: [id] }).then(() => {
          this.$message.success("操作成功!");
          this.handleSearch();
        });
      });
    },
    // 批量删除
    handleMoreDelete() {
      this.$confirm("此操作将永久删除所有选中数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const delCostIds = this.multipleSelection.map((v) => v.costId);

        this.apiCostDeletelist({ delCostIds }).then(() => {
          this.$message.success("操作成功!");
          this.handleSearch();
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
